module.exports = __webpack_public_path__ + "static/neighbor-b1e41766e86efe99317f6b714d429b01.jpg";